/* Helpers communs à la pêche (espèces) et à la chasse (gibiers). */

export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
export const TEMP_GUID = 'FFFFFFFF-FFFF-FFFF-FFFF-FFFFFFFFFFFF';

export function asArray(value) {
  return Array.isArray(value) ? value : [];
}

export function getActiviteId(activite) {
  return activite?.idActivite || activite?.id;
}

export function captureDetailHasQuantity(detail) {
  const fields = [
    'completQuantite', 'eviscereQuantite', 'eteteQuantite',
    'consommeQuantite', 'nonPeseeQuantite', 'remisAEau',
  ];
  return fields.some(field => Number(detail[field]) > 0);
}

/** Pairs quantité → masse (pêche) : masse obligatoire si quantité > 0. */
export const PECHE_QUANTITE_MASSE_PAIRS = [
  ['completQuantite', 'completMasse'],
  ['eviscereQuantite', 'eviscereMasse'],
  ['eteteQuantite', 'eteteMasse'],
];

export function captureDetailHasRequiredMasses(detail) {
  return PECHE_QUANTITE_MASSE_PAIRS.every(([quantiteField, masseField]) => {
    if (Number(detail[quantiteField]) > 0) {
      return Number(detail[masseField]) > 0;
    }
    return true;
  });
}

export function getMissingMasseFields(detail) {
  return PECHE_QUANTITE_MASSE_PAIRS
    .filter(([quantiteField, masseField]) =>
      Number(detail[quantiteField]) > 0 && !(Number(detail[masseField]) > 0)
    )
    .map(([, masseField]) => masseField);
}

export function estReponseOuiNon(value) {
  return value !== null && value !== undefined;
}

export function obtenirIdsRoundsBloc(block) {
  return [...new Set((block.especeRounds || []).map(round => String(round.speciesId)))];
}

export function obtenirIdsUniques(capturesDetails, obtenirId) {
  return [...new Set((capturesDetails || [])
    .map(obtenirId)
    .filter(Boolean)
    .map(String))];
}

export function obtenirIdsUtilisesBloc(block) {
  const utilises = new Set(obtenirIdsRoundsBloc(block));
  const idActif = String(block.activeEspeceId || '');
  if (idActif) {
    utilises.add(idActif);
  }
  return [...utilises];
}

export function obtenirNombreRestantsBloc(block, obtenirId) {
  const tousLesIds = obtenirIdsUniques(block.capturesDetails, obtenirId);
  return tousLesIds.length - obtenirIdsUtilisesBloc(block).length;
}

export function trouverDetailParId(capturesDetails, id, obtenirId) {
  const idCherche = String(id || '');
  if (!idCherche) {
    return null;
  }
  return (capturesDetails || []).find(
    detail => String(obtenirId(detail)) === idCherche
  ) || null;
}

export function obtenirLieuxDisponibles(allLieux, lieux, index, champId) {
  const selectedElsewhere = lieux
    .filter((_, i) => i !== index)
    .map(lieu => lieu[champId])
    .filter(Boolean);

  return allLieux.filter(lieu =>
    lieu[champId] === lieux[index][champId]
    || !selectedElsewhere.includes(lieu[champId])
  );
}

export function aPlusDeLieuxDisponibles(allLieux, lieux, champId) {
  const selected = new Set(lieux.map(lieu => lieu[champId]).filter(Boolean));
  return allLieux.some(lieu => !selected.has(lieu[champId]));
}

export function blocLieuEstComplet(block, champId) {
  return Boolean(block?.[champId])
    && Number(block.nombrePersonnes) > 0
    && Number(block.nombreJours) > 0;
}

export function indexBlocAutreLieu(lieux, champId) {
  if (!lieux.length) {
    return -1;
  }

  let lastCompleteIndex = -1;
  for (let i = 0; i < lieux.length; i++) {
    if (blocLieuEstComplet(lieux[i], champId)) {
      lastCompleteIndex = i;
    }
  }

  return lastCompleteIndex >= 0 ? lastCompleteIndex : lieux.length - 1;
}

export function toNumber(value) {
  const n = Number(value);
  return Number.isNaN(n) ? 0 : n;
}

export function toDecimal(value) {
  const n = parseFloat(value);
  return Number.isNaN(n) ? 0 : n;
}